<template>
  <v-container class="mt-3">
    <v-row v-if="isEditableEnrollment">
      <v-col cols="12" class="mt-0 pt-0 d-flex">
        <v-spacer />
        <v-btn
          color="secondary"
          class="text-none ml-3"
          small
          :to="{
            name: 'editEnrollments',
            params: { enrollmentYear: enrollmentYear.uuid },
          }"
          ><v-icon x-small>mdi-pencil</v-icon>Edit Enrollment</v-btn
        >
      </v-col>
    </v-row>
    <template v-for="enrollmentTerm in sortedEnrollmentTerms">
      <v-row class="grey lighten-3 py-2" :key="enrollmentTerm.uuid + '1'">
        <v-col cols="12" class="my-0 py-0">
          <span class="mb-0 mr-1 ml-4 primary--text font-weight-medium">
            Term:
          </span>
          <span class="mb-0 black--text">
            {{ enrollmentTerm.academic_term.academic_term }}
          </span>
        </v-col>
      </v-row>
      <v-simple-table
        dense
        class="mt-5 mb-10 simple-table"
        :key="enrollmentTerm.uuid + '2'"
      >
        <thead>
          <tr>
            <th class="primary--text" width="400">
              <span class="primary--text">Subject</span>
            </th>
            <th class="primary--text">
              <span class="primary--text">ECTS</span>
            </th>
            <th class="primary--text">
              <span class="primary--text">Is Elective</span>
            </th>
            <th class="primary--text">
              <span class="primary--text">Out Of Program</span>
            </th>
            <th class="primary--text">
              <span class="primary--text">Campus</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="enrollmentDetail in enrollmentTerm.enrollment_details"
            :key="enrollmentDetail.uuid"
          >
            <td>
              <v-container>
                <v-row>
                  <v-col cols="12" class="ma-0 pa-0">
                    {{ getSubjectText(enrollmentDetail) }}
                  </v-col>
                </v-row>
              </v-container>
            </td>
            <td>{{ getEctsText(enrollmentDetail) }}</td>
            <td>{{ getIsElectiveText(enrollmentDetail) }}</td>
            <td>{{ getOutOfProgramText(enrollmentDetail) }}</td>
            <td>
              {{
                enrollmentDetail.program_term_detail &&
                enrollmentDetail.program_term_detail.campus &&
                enrollmentDetail.program_term_detail.campus.campus_desc
              }}
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="font-weight-bold">
              {{
                enrollmentTerm.enrollment_details
                  .map((enrollmentDetail) =>
                    enrollmentDetail.program_term_detail
                      ? enrollmentDetail.program_term_detail.subject.ects
                      : 0
                  )
                  .reduce((a, b) => a + b, 0)
              }}
            </td>
            <td colspan="2"></td>
          </tr>
        </tbody>
      </v-simple-table>
    </template>
  </v-container>
</template>

<script>
import {
  enrollmentDetailIsElectiveOptions,
  outOfProgramOptions,
} from "@/utilities/constants-utility";
export default {
  props: ["enrollmentTerms", "enrollmentYear"],
  computed: {
    configurations() {
      return this.$store.getters["common/configurations"];
    },
    sortedEnrollmentTerms() {
      const enrollmentTerms = this.enrollmentTerms
        ? [...this.enrollmentTerms]
        : [];
      return enrollmentTerms.sort((a, b) =>
        a.academic_term.academic_term > b.academic_term.academic_term ? 1 : -1
      );
    },
    isEditableEnrollment() {
      const configurations = this.$store.state.common.configurations;
      return (
        this.$moment(configurations.enrollment_start_date).isBefore(
          this.$moment()
        ) &&
        this.$moment(configurations.enrollment_end_date).isAfter(
          this.$moment()
        ) &&
        configurations.edit_enrollment_student_status.includes(
          this.enrollmentYear?.student_status?.uuid
        )
      );
    },
  },
  methods: {
    getSubjectText(enrollmentDetail) {
      return enrollmentDetail.program_term_detail &&
        enrollmentDetail.program_term_detail.subject
        ? `${enrollmentDetail.program_term_detail.subject.subject_code} ${enrollmentDetail.program_term_detail.subject.subject_desc}`
        : "";
    },
    getEctsText(enrollmentDetail) {
      return enrollmentDetail.program_term_detail &&
        enrollmentDetail.program_term_detail.subject
        ? enrollmentDetail.program_term_detail.subject.ects
        : "";
    },
    getOutOfProgramText(enrollmentDetail) {
      const isElectiveOption = outOfProgramOptions.find(
        (option) => option.value === enrollmentDetail.out_of_program
      );
      return isElectiveOption ? isElectiveOption["text"] : "";
    },
    getIsElectiveText(enrollmentDetail) {
      const isElectiveOption = enrollmentDetailIsElectiveOptions.find(
        (option) => option.value === enrollmentDetail.is_elective
      );
      return isElectiveOption ? isElectiveOption["text"] : "";
    },
  },
};
</script>

<style></style>
